<template>
  <b-row class="match-height">
    <b-col
      lg="6"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 440px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <span style="font-size:20px; color: #fff; margin-left: 15px;">สัดส่วนยานพาหนะแต่ละประเภททุกสายทาง</span>
        </div>
        <div class="pie-text text-center">
          <h3 class="font-weight-bold">
            โดยรวม
          </h3>
          <h2 class="font-weight-bolder">
            {{ Total }}
          </h2>
        </div>
        <div class="chart">
          <app-echart-doughnut
            :series="series"
          />
        </div>
      </b-card>
    </b-col>
    <b-col
      lg="6"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <b-img
            style="margin-top: -5px"
            src="@/assets/images/icons/count1.svg"
          />
          <span style="font-size:20px; color: #fff; margin-left: 15px;">ปริมาณจราจรทุกสายทาง</span>
        </div>
        <div>
          <app-echart-bar
            :option-data="optionBar"
            style="width:auto; height:350px;"
          />
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEchartDoughnut from '@/views/traffic/total/echartDoughnut/AppEchartDoughnut1.vue'
import AppEchartBar from '@/views/traffic/total/AppEchartBartraffic.vue'

export default {
  components: {
    BRow,
    BCol,
    AppEchartBar,
    AppEchartDoughnut,
    BImg,
    BCard,
  },
  data() {
    return {
      optionBar: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#FAD6A5',
              },
              {
                offset: 1,
                color: '#FF8B13',
              },
              ]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },

      // กราฟโดนัท
      Total: '',
      series: [
        {
          color: ['#579BFE', '#DC48FF', '#8246FE', '#FE447A', '#4EAF51', '#FF805D', '#FDFF01'],
          name: 'ประเภท',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} ',
          },
          labelLine: {
            show: true,
          },
          data: [
            {
              value: '', name: 'รถยนต์', iconColor: '#579BFE', percent: '',
            },
            {
              value: '', name: 'รถจักรยานยนต์', iconColor: '#DC48FF', percent: '',
            },
            {
              value: '', name: 'รถแท็กซี่', iconColor: '#8246FE', percent: '',
            },
            {
              value: '', name: 'รถกระบะ', iconColor: '#FE447A', percent: '',
            },
            {
              value: '', name: 'รถบัส', iconColor: '#4EAF51', percent: '',
            },
            {
              value: '', name: 'รถบรรทุก', iconColor: '#FF805D', percent: '',
            },
            {
              value: '', name: 'รถพ่วง', iconColor: '#FDFF01', percent: '',
            },
          ],
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getPieData()
    this.getBarChart()
    this.interval = setInterval(() => {
      this.getPieData()
    }, 300000)
  },
  methods: {

    // กราฟโดนัท
    getPieData() {
      axios
        .post('/getPercentCountDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.series[0].data[0].value = response.data[0].Car
          this.series[0].data[1].value = response.data[0].Bike
          this.series[0].data[2].value = response.data[0].Taxi
          this.series[0].data[3].value = response.data[0].Pickup
          this.series[0].data[4].value = response.data[0].Bus
          this.series[0].data[5].value = response.data[0].Truck
          this.series[0].data[6].value = response.data[0].Trailer

          this.series[0].data[0].percent = parseFloat((response.data[0].Car / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[1].percent = parseFloat((response.data[0].Bike / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[2].percent = parseFloat((response.data[0].Taxi / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[3].percent = parseFloat((response.data[0].Pickup / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[4].percent = parseFloat((response.data[0].Bus / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[5].percent = parseFloat((response.data[0].Truck / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[6].percent = parseFloat((response.data[0].Trailer / response.data[0].Total) * 100).toFixed(2)
          // eslint-disable-next-line prefer-destructuring
          this.Total = response.data[0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getBarChart() {
      axios
        .post('/getBarWattLightingTotal', { department: this.userData.department })
        .then(response => {
          this.xAxisData = []
          this.optionBar.xAxisData.splice(0)
          this.optionBar.series[0].data.splice(0)
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.optionBar.xAxisData.push(value.date_time)
            this.optionBar.series[0].data.push(value.watt)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },

  },
}
</script>

<style scoped lang="scss">
.pie-text{
      width: 200px;
      position:absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 45%;
      bottom: 0;
    }
.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
